import { PbError } from '@owner/errors'

class ConnectionError extends PbError {
  constructor(args) {
    super(args.message, args)
    this.name = 'ConnectionError'
    this.code = args.code
    this.message = args.message
    this.status = args.status
  }
}

export { ConnectionError }
